define('app/views/templates/helpers/checkClubInfoPrivacy',['Handlebars','underscore'], function ( Handlebars, _ ){
    function checkClubInfoPrivacy(infoType) {
        var tempClubShow = _.map ( Customization.club.show, function(string){
        return "^"+ string.replace(/ /g, "").trim().toLowerCase() + "$";
        });
        infoType = infoType.replace(/ /g, "").trim();
        var regex = new RegExp( tempClubShow.join( "|" ), "i");
        return regex.test(infoType) && tempClubShow.length ? true : false;
    }

    Handlebars.registerHelper( 'checkClubInfoPrivacy', checkClubInfoPrivacy );
    return checkClubInfoPrivacy;
});
